import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useMemo } from 'react';
import { BuildingOfficeIcon, UserGroupIcon, BriefcaseIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { getAssetSrc } from '@restworld/utils-common';
import { Card, Title } from '../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var RestaurantStatistics = function RestaurantStatistics(_ref) {
  var covers = _ref.covers,
      staffSize = _ref.staffSize,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'horizontal' : _ref$variant;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var statisticsEl = useMemo(function () {
    return [].concat(_toConsumableArray(covers ? [{
      key: 'covers-number',
      content: covers,
      icon: 'SpoonPlateIcon',
      iconTitle: t('covered') // content: `${coversNumber ? `${coversNumber}/80` : '-'}`,

    }] : []), _toConsumableArray(staffSize ? [{
      key: 'staff-size',
      content: staffSize,
      icon: 'UserGroupIcon',
      iconTitle: 'Staff'
    }] : [])).map(function (_ref2) {
      var key = _ref2.key,
          content = _ref2.content,
          icon = _ref2.icon,
          iconTitle = _ref2.iconTitle;
      return variant === 'vertical' ? /*#__PURE__*/_jsx(RestaurantStatisticsCardVariantTwo, {
        content: content,
        icon: icon,
        iconTitle: iconTitle
      }, key) : /*#__PURE__*/_jsx(RestaurantStatisticsCardVariantOne, {
        content: content,
        icon: icon,
        iconTitle: iconTitle,
        cardVariant: "gray100",
        contentStyling: {
          "fontSize": "1.5rem",
          "lineHeight": "2.25rem",
          "fontWeight": "600",
          "--tw-text-opacity": "1",
          "color": "rgb(107 114 128 / var(--tw-text-opacity))"
        },
        titleStyling: {
          "fontSize": "1rem",
          "lineHeight": "1.5rem",
          "fontWeight": "400",
          "--tw-text-opacity": "1",
          "color": "rgb(107 114 128 / var(--tw-text-opacity))"
        },
        noShadow: true
      }, key);
    });
  }, [covers, staffSize, t, variant]);
  return variant === 'vertical' ? /*#__PURE__*/_jsx(_StyledDiv, {
    children: statisticsEl
  }) : /*#__PURE__*/_jsx(_StyledDiv2, {
    children: statisticsEl
  });
};

var RestaurantStatisticsCardVariantOne = function RestaurantStatisticsCardVariantOne(_ref3) {
  var content = _ref3.content,
      icon = _ref3.icon,
      iconTitle = _ref3.iconTitle,
      _ref3$cardVariant = _ref3.cardVariant,
      cardVariant = _ref3$cardVariant === void 0 ? 'primary50' : _ref3$cardVariant,
      _ref3$cardCentered = _ref3.cardCentered,
      cardCentered = _ref3$cardCentered === void 0 ? false : _ref3$cardCentered,
      titleStyling = _ref3.titleStyling,
      contentStyling = _ref3.contentStyling,
      noShadow = _ref3.noShadow;
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsxs(Card, {
      variant: cardVariant,
      twStyle: cardCentered ? {
        "minHeight": "fit-content"
      } : {
        "minHeight": "fit-content",
        "alignItems": "center",
        "gap": "0.5rem"
      },
      noShadow: noShadow,
      children: [/*#__PURE__*/_jsx(Title, {
        content: content,
        fontSize: "extraLarge",
        textColor: "bold-purple",
        twStyle: contentStyling
      }), /*#__PURE__*/_jsx(Title, {
        icon: icon,
        content: iconTitle,
        textColor: "gray",
        twStyle: titleStyling
      })]
    })
  });
};

var RestaurantStatisticsCardVariantTwo = function RestaurantStatisticsCardVariantTwo(_ref4) {
  var content = _ref4.content,
      icon = _ref4.icon,
      iconTitle = _ref4.iconTitle,
      _ref4$titleStyling = _ref4.titleStyling,
      titleStyling = _ref4$titleStyling === void 0 ? {
    "lineHeight": "1rem"
  } : _ref4$titleStyling,
      _ref4$contentStyling = _ref4.contentStyling,
      contentStyling = _ref4$contentStyling === void 0 ? {} : _ref4$contentStyling;
  return /*#__PURE__*/_jsxs(_StyledDiv3, {
    children: [/*#__PURE__*/_jsx(_StyledDiv4, {
      children: {
        SpoonPlateIcon: /*#__PURE__*/_jsx(_StyledImg, {
          src: getAssetSrc('/utils-assets/spoon-plate.svg'),
          alt: ""
        }),
        UserGroupIcon: /*#__PURE__*/_jsx(UserGroupIcon, {
          className: "h-6 w-6 text-gray-600"
        }),
        BuildingOfficeIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
          className: "h-6 w-6 text-primary-800"
        }),
        BriefcasePurple800Icon: /*#__PURE__*/_jsx(BriefcaseIcon, {
          className: "h-6 w-6 text-primary-800"
        })
      }[icon]
    }), /*#__PURE__*/_jsxs(_StyledDiv5, {
      children: [/*#__PURE__*/_jsx(Title, {
        content: iconTitle,
        fontSize: "xSmall",
        fontWeight: "medium",
        textColor: "gray-600",
        twStyle: titleStyling
      }), /*#__PURE__*/_jsx(Title, {
        content: content,
        fontSize: "base",
        fontWeight: "semibold",
        textColor: "black",
        twStyle: contentStyling
      })]
    })]
  });
};

export default RestaurantStatisticsCardVariantOne;
export { RestaurantStatistics, RestaurantStatisticsCardVariantTwo, RestaurantStatisticsCardVariantOne };

var CardWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "restaurant-statistics-card__CardWrapper",
  componentId: "sc-1k4mnpg-0"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "gap": "0.5rem",
  "--tw-shadow": "0 0 #0000",
  "--tw-shadow-colored": "0 0 #0000",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "restaurant-statistics-card___StyledDiv",
  componentId: "sc-1k4mnpg-1"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "1rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "restaurant-statistics-card___StyledDiv2",
  componentId: "sc-1k4mnpg-2"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "gap": "0.5rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "restaurant-statistics-card___StyledDiv3",
  componentId: "sc-1k4mnpg-3"
})({
  "display": "flex",
  "flexDirection": "row",
  "gap": "0.5rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "restaurant-statistics-card___StyledDiv4",
  componentId: "sc-1k4mnpg-4"
})({
  "display": "inline-flex",
  "height": "2.5rem",
  "width": "2.5rem",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.625rem",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "padding": "0.5rem"
});

var _StyledImg = /*#__PURE__*/_styled("img").withConfig({
  displayName: "restaurant-statistics-card___StyledImg",
  componentId: "sc-1k4mnpg-5"
})({
  "height": "1.5rem",
  "width": "1.5rem"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "restaurant-statistics-card___StyledDiv5",
  componentId: "sc-1k4mnpg-6"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start"
});